import { Box, Typography } from "@mui/material"
import type { ReactElement } from "react"
import React from "react"

import AssociateProductButton from "../instructionProducts/AssociateProductButton"
import { AssociatedProductsTable } from "../tables/AssociatedProductsTable"

import type { InstructionProduct } from "@/graphql/codegen/graphql"

const AssociatedProductsArea = ({
  products,
  openAddProductDialog,
}: {
  products: InstructionProduct[]
  openAddProductDialog: () => void
}): ReactElement => {
  return (
    <Box className='mb-6 flex flex-col border-t border-t-gray-400 px-6'>
      <Box className='my-6 flex justify-between align-middle'>
        <Typography className={"text-ml text-slate-800"}>Associated Products</Typography>
        <AssociateProductButton onClick={openAddProductDialog} />
      </Box>
      <AssociatedProductsTable products={products} />
    </Box>
  )
}

export default AssociatedProductsArea
